"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.post = exports.get = void 0;
const axios_1 = __importDefault(require("axios"));
const token_1 = require("../storage/token");
const get = (url_1, ...args_1) => __awaiter(void 0, [url_1, ...args_1], void 0, function* (url, requestAuth = false, params = {}) {
    const headers = {
        "Content-Type": "application/json",
    };
    if (requestAuth) {
        headers["Authorization"] = `${(0, token_1.getToken)()}`;
    }
    return axios_1.default
        .get(url, {
        headers,
        params,
    })
        .then((response) => response.data);
});
exports.get = get;
const post = (url_1, data_1, ...args_1) => __awaiter(void 0, [url_1, data_1, ...args_1], void 0, function* (url, data, requestAuth = false) {
    const headers = {
        "Content-Type": "application/json",
    };
    if (requestAuth) {
        headers["Authorization"] = `${(0, token_1.getToken)()}`;
    }
    return axios_1.default
        .post(url, data, {
        headers,
    })
        .then((response) => response.data);
});
exports.post = post;
